import {IOfferBoxOffer} from "../types/IOfferBoxOffer";
import {getOfferCardAddress} from "./get_offer_card_address";

/**
 * Default title for the USP tile variant when its parent does not provide a search context.
 */
export const getOfferCardTitle = (offer: IOfferBoxOffer): string => {
    return getOfferCardAddress(offer) || offer.name;
};

export const getOfferCardSubtitle = (offer: IOfferBoxOffer): string => {
    const vendorName = offer.vendor.name;

    return vendorName ? `${offer.name} | ${vendorName}` : offer.name;
};
import {IOfferBoxOffer} from "../types/IOfferBoxOffer";
import {getOfferCardAddress} from "./get_offer_card_address";

/**
 * Default title for the USP tile variant when its parent does not provide a search context.
 */
export const getOfferCardTitle = (offer: IOfferBoxOffer): string => {
    return getOfferCardAddress(offer) || offer.name;
};

export const getOfferCardSubtitle = (offer: IOfferBoxOffer): string => {
    const vendorName = offer.vendor.name;

    return vendorName ? `${offer.name} | ${vendorName}` : offer.name;
};
